import React from 'react';
import ClientCopyConfigTree from './ClientCopyConfigTree';
import { ClientCopyConfigContextProvider } from './ClientCopyConfigContext';

const ClientFormContainer: React.FC = (): React.ReactElement => {
    return (
        <ClientCopyConfigContextProvider>
            <ClientCopyConfigTree />
        </ClientCopyConfigContextProvider>
    );
};

export default ClientFormContainer;
